"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _d3Selection = require("d3-selection");
require("./plottable.css");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // Could also be expressed as plottable/plottable.css, but babel-plugin-transform-postcss does not resolve that reference correctly
/**
 * Renders a Plottable "component" (not React component) which is passed in through props.
 * Creates a container to render the Plottable component in and manages its lifecycle.
 */
var PlottableComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(PlottableComponent, _React$Component);
  function PlottableComponent(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PlottableComponent);
    _this = _callSuper(this, PlottableComponent, [props]);
    _this.saveRefToPlotContainer = _this.saveRefToPlotContainer.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(PlottableComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderPlottableComponent();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        plottableComponent = _this$props.plottableComponent,
        width = _this$props.width,
        height = _this$props.height;
      if (plottableComponent && plottableComponent !== prevProps.plottableComponent) {
        if (prevProps.plottableComponent && prevProps.plottableComponent.destroy) {
          prevProps.plottableComponent.destroy();
        }
        this.renderPlottableComponent();
      } else if (plottableComponent && (width !== prevProps.width || height !== prevProps.height)) {
        plottableComponent.redraw();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.plottableComponent && this.props.plottableComponent.destroy) {
        this.props.plottableComponent.destroy();
      }
    }
  }, {
    key: "saveRefToPlotContainer",
    value: function saveRefToPlotContainer(ref) {
      this.plotContainerRef = ref;
    }
  }, {
    key: "renderPlottableComponent",
    value: function renderPlottableComponent() {
      var _this$props2 = this.props,
        height = _this$props2.height,
        plottableComponent = _this$props2.plottableComponent,
        width = _this$props2.width;
      if (!plottableComponent || !plottableComponent.renderTo || !plottableComponent.anchor) {
        return;
      }
      if (width && height) {
        plottableComponent.renderTo(this.plotContainerRef);
      } else {
        plottableComponent.anchor((0, _d3Selection.select)(this.plotContainerRef));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        height = _this$props3.height,
        width = _this$props3.width,
        testId = _this$props3.testId,
        description = _this$props3.description,
        ariaLabel = _this$props3['aria-label'],
        ariaLabelledby = _this$props3['aria-labelledby'];
      return /*#__PURE__*/_react["default"].createElement("div", {
        // eslint-disable-next-line jsx-a11y/aria-role
        role: "img",
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledby
        // React <=17 does not officially support the `aria-description` attribute
        // dev env render warnings may occur
        // https://github.com/facebook/react/issues/21035#issuecomment-913818467
        // eslint-disable-next-line jsx-a11y/aria-props
        ,
        "aria-description": description
      }, /*#__PURE__*/_react["default"].createElement("div", {
        // This hides the entire chart from assisitive technology
        "aria-hidden": "true",
        "data-test-id": testId,
        ref: this.saveRefToPlotContainer,
        style: {
          height: height,
          width: width
        }
      }));
    }
  }]);
  return PlottableComponent;
}(_react["default"].Component);
var _default = exports["default"] = PlottableComponent;
//# sourceMappingURL=PlottableComponent.js.map